/**
 * Time left, as the shell's countdowns show it (`ChallengeCard`'s `endsAt`).
 * Unit letters, not words, so it reads the same in every language a game
 * speaks; a game that wants words passes its own `formatCountdown`.
 *
 *   5 days 1 hour 20 minutes  → "5d 01h"
 *   7 hours 12 minutes        → "7h 12m"
 *   45 minutes 10 seconds     → "45m"
 *   42 seconds                → "42s"
 *   0 or less                 → "0s"
 *
 * Every unit is floored: the countdown never claims more time than is left.
 */
export function formatTimeLeft(ms: number): string {
  const left = Math.max(0, Math.floor(ms / 1000));
  const days = Math.floor(left / 86_400);
  const hours = Math.floor((left % 86_400) / 3600);
  const minutes = Math.floor((left % 3600) / 60);
  const seconds = left % 60;
  const two = (n: number): string => String(n).padStart(2, '0');
  if (days > 0) return `${String(days)}d ${two(hours)}h`;
  if (hours > 0) return `${String(hours)}h ${two(minutes)}m`;
  if (minutes > 0) return `${String(minutes)}m`;
  return `${String(seconds)}s`;
}

/**
 * How long until a countdown showing `ms` left next changes: at the next
 * whole minute while more than a minute is left, at the next whole second in
 * the last minute. Always at least 1 ms.
 */
export function nextTickIn(ms: number): number {
  if (ms <= 0) return 1000;
  if (ms > 60_000) return ms % 60_000 || 60_000;
  return ms % 1000 || 1000;
}
